var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "text-left" },
      [
        !_vm.savedChanges
          ? [
              _c("transition", { attrs: { name: "slide-fade" } }, [
                _c("div", { staticClass: "preview" }, [
                  _vm._v("\n          This is a Preview\n        "),
                ]),
              ]),
            ]
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "content-creator-editor-container" },
          [
            _c(
              "no-ssr",
              [
                _vm.canBeUsed
                  ? _c("content-creator-editor", {
                      key: 2,
                      attrs: {
                        filestore: _vm.filestore,
                        name: _vm.name,
                        "allowed-widgets": _vm.allowedWidgets,
                        "edit-permissions": _vm.editPermissions,
                        permissions: _vm.permissions,
                        "menu-style": _vm.menuStyle,
                        "menu-reduce": _vm.menuReduce,
                        "menu-selection": _vm.menuSelection,
                        "is-visible": _vm.isVisible,
                        "saved-changes": _vm.savedChanges,
                        "save-pending": _vm.savePending,
                      },
                      on: { updateBlob: _vm.updateBlob },
                      model: {
                        value: _vm.widget,
                        callback: function ($$v) {
                          _vm.widget = $$v
                        },
                        expression: "widget",
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _vm.isMenu && !_vm.menuEmpty
              ? [
                  _c("content-menu-editor", {
                    key: 3,
                    attrs: {
                      widget: _vm.widget,
                      "menu-style": _vm.menuStyle,
                      "menu-reduce": _vm.menuReduce,
                      "menu-selection": _vm.menuSelection,
                      "menu-direction": _vm.menuDirection,
                      "saved-changes": _vm.savedChanges,
                      "menu-container-entry-name": _vm.selectedMenuEntry,
                    },
                  }),
                ]
              : _vm.isMenu
              ? [
                  _vm.isMenu && _vm.menuEmpty
                    ? _c("content-none", {
                        attrs: {
                          filestore: _vm.filestore,
                          widget: _vm.widget,
                          name: _vm.name,
                          permissions: _vm.permissions,
                        },
                      })
                    : _vm._e(),
                ]
              : _vm._e(),
          ],
          2
        ),
        _vm._v(" "),
        _vm.isNonMenu
          ? _c(
              "div",
              {
                key: _vm.widgetType,
                staticClass: "content-creator-layout-container",
              },
              [
                _vm.hasHeader
                  ? [
                      _c("content-header", {
                        attrs: {
                          header: _vm.widgetSettings.header,
                          filestore: _vm.filestore,
                        },
                      }),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                !_vm.showPlaceholder
                  ? _c(_vm.layoutComponent, {
                      key: 4,
                      tag: "component",
                      attrs: {
                        widget: _vm.widget,
                        name: _vm.name,
                        filestore: _vm.filestore,
                      },
                    })
                  : _c("content-none", {
                      attrs: {
                        filestore: _vm.filestore,
                        widget: _vm.widget,
                        name: _vm.name,
                        permissions: _vm.permissions,
                      },
                    }),
              ],
              2
            )
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }